export const COOKIE_TOKEN = 'token'
